import { FC, useCallback } from 'react'
import All from '../../../assets/icons/all.svg'
import Delivery from '../../../assets/icons/delivery.svg'
import TakeAway from '../../../assets/icons/take-away.svg'
import { ColorsEnum } from '../../constants/colors'
import { TabsEnum } from '../../constants/tabs'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { appSelectors, setCurrentTab } from '../../redux/reducers/app'
import { performHaptics } from '../../utils/performHaptics'
import Tab from '../UI/Tabs/Tab'
import Tabs from '../UI/Tabs/Tabs'

const DeliveryTabs: FC = () => {
    const currentTab = useAppSelector(appSelectors.currentTab)

    const dispatch = useAppDispatch()

    const handlePress = useCallback(
        (index: TabsEnum) => {
            performHaptics()

            dispatch(setCurrentTab(index))
        },
        [dispatch]
    )

    return (
        <Tabs>
            <Tab
                selected={currentTab === 0}
                index={0}
                color={ColorsEnum.SECONDARY}
                onPress={handlePress}
                Icon={All}
            >
                Vše
            </Tab>
            <Tab
                selected={currentTab === 1}
                index={1}
                color={ColorsEnum.SECONDARY}
                onPress={handlePress}
                Icon={Delivery}
            >
                Rozvoz
            </Tab>
            <Tab
                selected={currentTab === 2}
                index={2}
                color={ColorsEnum.SECONDARY}
                onPress={handlePress}
                Icon={TakeAway}
            >
                Osobně
            </Tab>
        </Tabs>
    )
}

export default DeliveryTabs
